<template>
  <section class="relative flex items-center cursor-pointer" @click="toggleShoppingBag" :aria-label="$t('cart.cart')">
    <shopping-bag-logo class="-mt-2 ml-2 z-10"></shopping-bag-logo>
    <span class="rounded-full w-3 h-3 flex justify-center bg-b2c-red-300 text-white text-xs bottom-1 left-2 absolute z-20
    items-center font-sans-serif font-bold p-3" v-show="count > 0">
      {{ count }}
    </span>
  </section>
</template>

<script>
import ShoppingBagLogo from '@/components/graphics/ShoppingBagLogo.vue';
import { mapGetters } from 'vuex';

export default {
  components: { ShoppingBagLogo },

  computed: {
    ...mapGetters({
      count: 'cart/productsCount',
    }),
  },

  methods: {
    toggleShoppingBag() {
      this.$store.dispatch('cart/resetCartIfItHasTo');
      this.$store.dispatch('toggleShoppingBag');
    },
  },
};
</script>
